import { Component } from '@angular/core';

/**
 * Placeholder landing page for the PA receivables slot.
 * Replaced by the real Receivables build in Spec 11.
 */
@Component({
  selector: 'app-receivables',
  standalone: true,
  templateUrl: './receivables.component.html',
  styleUrl: './receivables.component.scss',
})
export class ReceivablesComponent {}
